import * as React from 'react';
import classnames from 'classnames';

const FormGroup = ({ columns =1 , children , className ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('form-group', {
            'form-group--half': columns === 2,
            'form-group--third': columns === 3
        }, className)
    }, children)
;

export { FormGroup as default };
//# sourceMappingURL=FormGroup.js.map
